// extracted by mini-css-extract-plugin
export default {"duration":"Duration_duration__d3CQJ"};